/**
 * Many realtime events about the same thing in a burst → one REST read, after the burst
 * (QA 19/10 round 2, point 7: on load / during a payment the admin read the same order 3 times
 * and the tables list 4 times — one read per event and per screen listening).
 *
 * coalesceByKey(run, waitMs)(key, ...args): runs ``run(...args)`` once, ``waitMs`` after the LAST
 * call for that key (the newest args win: the read then sees the final state). Every caller of
 * the burst gets the same promise.
 */
export function coalesceByKey(run, waitMs = 250) {
  const pending = new Map(); // key -> { timer, args, promise, resolve, reject }
  return function coalesced(key, ...args) {
    let p = pending.get(key);
    if (p) {
      clearTimeout(p.timer);
    } else {
      p = {};
      p.promise = new Promise((resolve, reject) => { p.resolve = resolve; p.reject = reject; });
      pending.set(key, p);
    }
    p.args = args;
    p.timer = setTimeout(() => {
      pending.delete(key);
      Promise.resolve()
        .then(() => run(...p.args))
        .then(p.resolve, p.reject);
    }, waitMs);
    return p.promise;
  };
}
